import React, { useEffect, useMemo } from 'react';
import './App.css';
import { AppStyled } from './App.styled';
import { observer } from 'mobx-react-lite';
import {themeStore, userStore, mobileStore, exchangesStore, Header, BASE_URL, StatisticsPage, NotFoundPage, useCheckMobile, chartStore} from '@root/common';
import { Route, Routes, useLocation } from 'react-router-dom';
import PlotGraphMenu from './components/PlotGraphMenu/PlotGraphMenu';
import UpperInfo from './components/Graph/UpperInfo/UpperInfo';
import LowerInfo from './components/Graph/LowerInfo/LowerInfo';
import plotmenuStore from './store/plotmenu.store';
import { API_BASE_URL, OUTER_API_BASE_URL, SOCKET_URL } from './const';
import { getSpreadInfo } from './api/chart.api';
import { getEnterSpread } from './components/Graph/utils';
import { Orders } from './components/Orders';

const App = observer(() => {
  const params = useLocation()
  const isMobile = useCheckMobile()

  useEffect(() => {
    if (params && userStore.isAuth) {
      plotmenuStore.loadDefaultOptions(params.search)
      userStore.loadDefaultOptions(params.search)
      exchangesStore.load()
      chartStore.fetchSpreadInfo = getSpreadInfo
      chartStore.getEnterSpread = getEnterSpread
      userStore.setBaseUrls({
        base: API_BASE_URL,
        socket: SOCKET_URL,
        outer: OUTER_API_BASE_URL
      })
    }
    
  }, [params, userStore.isAuth])

  useEffect(() => {
    mobileStore.isMobile = isMobile
  }, [isMobile])


  return (
    <AppStyled style={{backgroundColor: themeStore.bgColor}}>
      <Header showNotificationsPicker/>

      <Routes>
        <Route path={BASE_URL} element={<StatisticsPage PlotGraphMenu={PlotGraphMenu} UpperInfo={UpperInfo} LowerInfo={LowerInfo} Orders={Orders}/>}/>
        <Route path="*" element={<NotFoundPage/>}/>
      </Routes>
    </AppStyled>
  );
})

export default App;
